<template>
  <span class="svg-ico-x">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.50873 20.3583C5.21584 20.0654 5.21584 19.5905 5.50873 19.2976L18.2367 6.56971C18.5295 6.27682 19.0044 6.27682 19.2973 6.56971C19.5902 6.86261 19.5902 7.33748 19.2973 7.63037L6.56939 20.3583C6.2765 20.6512 5.80163 20.6512 5.50873 20.3583Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.50873 6.29779C5.80163 6.0049 6.2765 6.0049 6.56939 6.29779L19.2973 19.0257C19.5902 19.3186 19.5902 19.7935 19.2973 20.0864C19.0044 20.3793 18.5295 20.3793 18.2367 20.0864L5.50873 7.35846C5.21584 7.06556 5.21584 6.59069 5.50873 6.29779Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
